import React, { useState, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";

// apis

// utils
import {
  getLocalStorageData,
  deleteDraftFromLocalStorage,
} from "../../../utils/localStorage";

// components
import DraftBox from "../../../components/draft-box";

// globals
import {
  MAX_NUMBER_OF_NEW_DRAFTS,
  DRAFT_TYPE_OPTIONS,
} from "../../../globals/static-data";

import {
  Container,
  InnerContainer,
  Title,
  BoxesContainer,
  AddButtonContainer,
  WarningTextStyle,
  CircularPlusButton,
  OuterBoxesContainer,
  LogoContainer,
  ContainerHeader,
  OuterContainerHeader,
} from "./styles";

const DraftsSection = () => {
  const [drafts, setDrafts] = useState([]);

  const fetchDrafts = () => {
    const fetchedDrafts = getLocalStorageData();
    setDrafts(fetchedDrafts);
  };

  useEffect(() => {
    fetchDrafts();
  }, []);

  const addDraft = () => {
    const now = new Date();
    setDrafts([
      ...drafts,
      {
        id: uuidv4(),
        title: "",
        type: DRAFT_TYPE_OPTIONS[0],
        content: "",
        createdAt: now.toISOString(),
      },
    ]);
  };

  const handleDeleteDraft = (id) => {
    deleteDraftFromLocalStorage(id);
    fetchDrafts();
  };

  const isDraftLimitReached = drafts.length >= MAX_NUMBER_OF_NEW_DRAFTS;
  // test

  return (
    <Container>
      <InnerContainer>
        <OuterContainerHeader>
          <ContainerHeader>
            <Title>PasteNest</Title>
            <LogoContainer />
          </ContainerHeader>
          <WarningTextStyle>
            Pastes are currently limited to 20 and stored in your browser, they
            will be lost if you clear your browser data
          </WarningTextStyle>
        </OuterContainerHeader>
        <OuterBoxesContainer>
          <BoxesContainer>
            {drafts.map((draft) => (
              <DraftBox
                key={draft.id}
                id={draft.id}
                title={draft.title}
                type={draft.type}
                draftContent={draft.content}
                createdAt={draft.createdAt}
                deleteDraft={handleDeleteDraft}
                fetchDrafts={fetchDrafts}
              />
            ))}
            <AddButtonContainer>
              {!isDraftLimitReached && (
                <CircularPlusButton onClick={addDraft} />
              )}
            </AddButtonContainer>
          </BoxesContainer>
        </OuterBoxesContainer>
      </InnerContainer>
    </Container>
  );
};

export default DraftsSection;
